import { useApolloClient } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { useAuthToken } from "./useAuthToken";
import { useDeleteFcmTokenMutation } from "../graphql";

export const useLogout = () => {
    const history = useHistory();
    const { removeAuthToken, removeRole } = useAuthToken();
    const apolloClient = useApolloClient();
    const [deleteFcmToken] = useDeleteFcmTokenMutation();

    const logout = async () => {
        await deleteFcmToken();

        await apolloClient.clearStore();
        // @ts-ignore
        removeAuthToken();
        removeRole();
        localStorage.removeItem("user-language");

        history.push("/login");
    };
    return logout;
};
